import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'

import { addHearts } from 'src/fancy/hearts'

import SegmentedControl from './SegmentedControl'

const heartParams = target => {
  const rect = target.parentNode.querySelector('.fa-heart').getBoundingClientRect()
  return {
    count: 12,
    left: rect.left,
    top: rect.top,
    color: 'var(--color-secondary)',
  }
}

const Frequency = ({ i18n, frequencies, value, onChange }) => {
  if (frequencies.length < 2) return null

  // When all four frequencies render together the buttons get crowded
  // and we use the bare `option` label (Once / Monthly / Quarterly /
  // Annually). With fewer frequencies there's room to swap in the
  // imperative-mood `option_full` ("Give once" / "Give monthly"), which
  // reads more like a CTA. Falls back to the bare option when
  // option_full is undefined for a locale — only English defines it
  // today (see subscription_labels comment in widgets.en.yml).
  const options = frequencies.map(frequency => ({
    value: frequency,
    label: (
      <>
        {frequency === 'monthly' && (
          <FontAwesomeIcon icon={faHeart} className="text-secondary me-2" />
        )}
        {(frequencies.length < 4 && i18n.locale.startsWith('en'))
          && i18n.t(`subscription_labels.${frequency}.option_full`)
          || i18n.t(`subscription_labels.${frequency}.option`)
        }
      </>
    ),
  }))

  const handleChange = event => {
    const newValue = event.target.value
    onChange(newValue)
    if (newValue === 'monthly') {
      setTimeout(() => addHearts(heartParams(event.target)), 1)
    }
  }

  return (
    <fieldset>
      <legend className="sr-only">{i18n.t('subscription')}</legend>
      <SegmentedControl
        name="subscription"
        options={options}
        value={value}
        onChange={handleChange}
      />
    </fieldset>
  )
}

export default Frequency
